// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"809":"81dbda3ffa1c1d4d","969":"04d89fc3a5e98968"}[chunkId] + ".js";
};